import script from "./ProjectImportScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectImportScanner.vue?vue&type=script&setup=true&lang=js"

import "./ProjectImportScanner.vue?vue&type=style&index=0&id=14d813fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14d813fc"]])

export default __exports__